import moment from "moment";

export const ISO_FMT = "YYYY-MM-DD";

export const toISO = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    const parsedDate = moment(value);
    return parsedDate.isValid() ? parsedDate.format(ISO_FMT) : null;
  }

  const stringValue = String(value);
  if (/^\d{4}-\d{2}-\d{2}/.test(stringValue)) return stringValue.slice(0, 10);

  const parsed = moment(stringValue);
  return parsed.isValid() ? parsed.format(ISO_FMT) : null;
};

export const fmtBR = (iso) => {
  if (!iso) return "-";

  const parsed = moment(String(iso).slice(0, 10), ISO_FMT, true);
  return parsed.isValid() ? parsed.format("DD/MM/YYYY") : String(iso);
};

export const formatViewTitle = (title) => {
  if (!title) return "";

  const months = [
    "janeiro",
    "fevereiro",
    "marco",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro",
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez",
  ];

  let output = String(title);
  months.forEach((month) => {
    const rx = new RegExp(`\\b${month}\\b`, "gi");
    output = output.replace(rx, (match) => match.charAt(0).toUpperCase() + match.slice(1).toLowerCase());
  });

  return output.charAt(0).toUpperCase() + output.slice(1);
};

export const categoryColors = {
  Ferias: "#02ea75",
  Evento: "#805ad5",
  DayOff: "#3182ce",
  Folga: "#ecc94b",
};

export const getCategoryColor = (category) => categoryColors[category] || categoryColors.Ferias;
